<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-card
        v-if="userGessan"
        outlined
        class="app-card"
      >
        <v-card-title class="app-card-title">
          Informações do Município
          <div class="app-card-title-actions">
            <v-btn
              depressed
              small
              color="error"
              @click="logout()"
            >
              <v-icon
                left
                small
              >
                exit_to_app
              </v-icon>Sair
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="app-card-content py-3">
          <strong class="info-text">
            {{ userGessan?.isGrupo ? "Grupo Município" : "Município" }}:
            <em>{{ userGessan?.nome }} - {{ formatCnpj(userGessan?.cnpj) }}</em>
          </strong>
          <strong class="info-text">
            Responsável:
            <em>{{ userGessan?.nomeResponsavel }} - {{ userGessan?.cpfResponsavel | cpf }}</em>
          </strong>
        </v-card-text>
      </v-card>
      <v-btn
        v-if="!isHome"
        depressed
        small
        outlined
        color="primary"
        class="btn-back mb-4"
        @click="goBack()"
      >
        <v-icon
          left
          small
        >
          arrow_back
        </v-icon>Voltar
      </v-btn>
      <router-view />
    </v-container>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AuthService from "@/services/gessan/auth.service";
import { formatAlphanumericCNPJ } from "@/helpers/cnpj-alphanumeric.validator";
const actions = mapActions("siePedidos", [
  "setDadosParaSolicitacao",
  "setFormStep",
]);
const global = mapState("global", ["userGessan"]);

export default {
  computed: {
    ...global,
    isHome() {
      return this.$route.name === "saneamento-home";
    },
  },
  methods: {
    formatCnpj(value) {
      return formatAlphanumericCNPJ(value);
    },
    goBack() {
      this.$router.push({ name: "saneamento-home" });
    },
    logout() {
      AuthService.logout(true);
      AuthService.globalStore("success", "Saiu com sucesso!");
    },
    ...actions,
  },
};
</script>

<style lang="scss" scoped>
.app-card-content .info-text {
  margin-bottom: 0;

  & + .info-text {
    margin-top: 6px;
  }
}

.app-card-title {
  position: relative;
}

.app-card-title-actions {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  display: flex;
  gap: 8px;
}
</style>
